export const WIDGET_PAGE_SIZE = 10

export const WIDGET_EMAIL_PAGE_SIZE = 5

export const INIT_WIDGET_API_PARAMS = {
  size: WIDGET_PAGE_SIZE,
}

export const INIT_EMAIL_WIDGET_API_PARAMS = {
  size: WIDGET_EMAIL_PAGE_SIZE,
}
